import React from "react";

function SunIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <circle cx="12" cy="12" r="4" />
      <path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M6.34 17.66l-1.41 1.41M19.07 4.93l-1.41 1.41" />
    </svg>
  );
}

function MoonIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
    </svg>
  );
}

function ChatHeader({
  channelType,
  isOpen,
  dropdownRef,
  headerIcon,
  minimizeIcon,
  closeChatIcon,
  theme,
  onToggleTheme,
  onMinimize,
  onClose,
  onNewSession,
  onCloseBot,
}) {
  return (
    <div className="bot-header-container d-flex justify-between">
      <div className="left-header-container">
        <div className="header-avatar-wrap">
          <img src={headerIcon} alt="DIVA" />
          <span className="status-dot" aria-label="Online" />
        </div>
        <div className="header-title-block">
          <div className="left-hand-container-headerText">DIVA</div>
          <div className="header-subtitle">DTDC Virtual Assistant</div>
        </div>
      </div>
      <div className="right-header-container d-flex">
        <button
          type="button"
          className="header-icon-btn"
          onClick={onToggleTheme}
          aria-label={theme === "dark" ? "Switch to light mode" : "Switch to dark mode"}
          title={theme === "dark" ? "Light mode" : "Dark mode"}
        >
          {theme === "dark" ? <SunIcon /> : <MoonIcon />}
        </button>
        {channelType !== "mob" && (
          <>
            <img src={minimizeIcon} onClick={onMinimize} alt="minimize" />
            <img src={closeChatIcon} onClick={onClose} alt="close" />
            {isOpen && (
              <ul className="settings-dropdown" ref={dropdownRef}>
                <li className="profile-dispname" onClick={onNewSession}>
                  <span>New Session</span>
                </li>
                <li className="profile-dispname" onClick={onCloseBot}>
                  <span>Close</span>
                </li>
              </ul>
            )}
          </>
        )}
      </div>
    </div>
  );
}

export default ChatHeader;
